// import React, { useState, useEffect } from "react";
// import { FaTimes } from "react-icons/fa";
// import { useStateContext } from "../contexts/ContextProvider";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// const API_URL=process.env.REACT_APP_API_URL_V;
// const APKForm = ({ onCloseForm,fetchDataFromApkMaster }) => {
//   const { currentColor } = useStateContext();
//   const [appName, setAppName] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [selectedFilePath, setSelectedFilePath] = useState(null);
//   const [thumbnailFile, setThumbnailFile] = useState(null);
//   const [thumbnailFilePath, setThumbnailFilePath] = useState(null);
//   const [status, setStatus] = useState("active");
//   const [loading, setLoading] = useState(false);

//   const[apkTenantstatus,setApkTenantStatus]=useState("")
//   const [id, setId] = useState("");
//   // useEffect(() => {
//   //   // Fetch data from the backend when the component mounts
//   //   fetchDataFromApkMaster();
//   // }, []);
//   const [errors, setErrors] = useState({
//     appName: "",
//     id: "",
//     selectedFile: "",
//     thumbnailFile: "",
//     status: "",
//   });
//    // Validation function
//    const validateForm = () => {
//     let valid = true;
//     const newErrors = {
//       appName: "",
//       id: "",
//       selectedFile: "",
//       thumbnailFile: "",
//       status: "",
//     };
 
//     if (!appName || !appName.trim()) {
//       newErrors.appName = "App Name is required";
//       valid = false;
//     }
 
//     if (!id || !id.trim()) {
//       newErrors.id = "ID is required";
//       valid = false;
//     }
 
//     if (!selectedFile) {
//       newErrors.selectedFile = "APK File is required";
//       valid = false;
//     }
 
//     if (!thumbnailFile) {
//       newErrors.thumbnailFile = "Thumbnail File is required";
//       valid = false;
//     }
 
//     if (!status) {
//       newErrors.status = "Status is required";
//       valid = false;
//     }
 
//     setErrors(newErrors);
//     return valid;
//   };
 


  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     // Add your form submission logic here
//     const isValid = validateForm();
//     if (isValid) {
//       // Simulate form submission for demo purposes
     
//       try {
//         const formData = new FormData();
//         formData.append("name", appName);
//         formData.append("id", id);
//         formData.append("status", status);
//         formData.append("apk", selectedFile);
//         formData.append("thumbnail", thumbnailFile);

//         const accessToken = localStorage.getItem("accesstoken");
//         const response = await fetch( `${API_URL}/apkmaster`, {
//           method: "POST",
//           headers: {
//             // No need to set Content-Type for FormData
//             "x-auth-token": accessToken,
//           },
//           body: formData,
//         });
//         if (response.ok) {
//           const responseData = await response.json();
//           fetchDataFromApkMaster();
//           toast.success('Data created successfully', {
//             position: 'bottom-right',
//             autoClose: 5000, 
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//           });
//           console.log("Form submitted successfully", responseData);
          
//           // Reset the form fields and selected file state after submission
//           setAppName("");
//           setSelectedFile(null);
//           setSelectedFilePath(null);
//           setThumbnailFile(null);
//           setThumbnailFilePath(null);
//           setStatus("");
//           setApkTenantStatus("");
//           setId("");
//           onCloseForm(); 
          
//         } 
        
        
//         else {
          
//           const responseData = await response.json();
//           console.log(responseData.message)
//           setApkTenantStatus(responseData.message);
//           console.error("Form submission failed");
         
//         }
        
       
//       } catch (error) {
//         console.error("Error during form submission", error);
       
//         toast.error('Error updating data', {
//           position: 'bottom-right',
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//         });
//       }
//     } 
//   };
//   const handleFileChange = (e) => {
//     const file =
//       e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
//     console.log(file);
//     setSelectedFile(file);
//     // Display the selected file path
//     if (file) {
//       setSelectedFilePath(`Selected File: ${file.name}`);
//     } else {
//       setSelectedFilePath(null);
//     }
//   };
//   const handleDragOverFile = (e) => {
//     e.preventDefault();
//   };
//   const handleDropFile = (e) => {
//     e.preventDefault();
//     const file = e.dataTransfer.files[0];
//     setSelectedFile(file);
//     if (file) {
//       setSelectedFilePath(`Selected File: ${file.name}`);
//     } else {
//       setSelectedFilePath(null);
//     }
//   };
//   const handleThumbnailChange = (e) => {
//     const file =
//       e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
//     setThumbnailFile(file);

//     // Display the selected thumbnail file path
//     if (file) {
//       setThumbnailFilePath(`Selected Thumbnail: ${file.name}`);
//     } else {
//       setThumbnailFilePath(null);
//     }
//   };

//   const handleDragOverThumbnail = (e) => {
//     e.preventDefault();
//   };

//   const handleDropThumbnail = (e) => {
//     e.preventDefault();
//     const file = e.dataTransfer.files[0];
//     setThumbnailFile(file);

//     if (file) {
//       setThumbnailFilePath(`Selected Thumbnail: ${file.name}`);
//     } else {
//       setThumbnailFilePath(null);
//     }
//   };

//   return (
//     <div className="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center overflow-y">
//       <div className="modal bg-white w-full max-w-md p-6 rounded-lg overflow-y">
//         <div className="relative bg-white rounded-lg shadow">
//           <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
//           <h3 className="text-lg font-semibold text-gray-900">
//               APK Details
//             </h3>
//             <button
//               type="button"
//               onClick={onCloseForm}
//               className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 cursor-pointer absolute top-4 right-4"
//             >
//               <FaTimes />
//             </button>
//           </div>
//             <div className="max-h-80 overflow-y-auto relative p-5">
//             <form
//               className="mt-2 space-y-2 "
//               onSubmit={handleSubmit}
//               encType="multipart/form-data"
//             >
//               <div className="grid grid-cols-1 space-y-2">
//                 <label className="text-sm font-bold text-gray-500 tracking-wide">
//                   Apk Name
//                 </label>
//                 <input
//                   value={appName}
//                   onChange={(e) => setAppName(e.target.value)}
//                   className="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
//                   type="text"
//                   placeholder="Your App Name"
//                 />
//               </div>
//               {errors.appName && (
//                 <p className="text-red-500 text-sm">{errors.appName}</p>
//               )}
//               <div className="grid grid-cols-1 space-y-2">
//                 <label className="text-sm font-bold text-gray-500 tracking-wide">
//                   ID
//                 </label>
//                 <input
//                   value={id}
//                   onChange={(e) => setId(e.target.value)}
//                   className="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
//                   type="text"
//                   placeholder="Your App ID"
//                 />
//               </div>
//               {errors.id && <p className="text-red-500 text-sm">{errors.id}</p>}
//               <div
//                 className="grid grid-cols-1 space-y-2"
//                 onDragOver={handleDragOverFile}
//                 onDrop={handleDropFile}
//               >
//                 <label className="text-sm font-bold text-gray-500 tracking-wide mt-4">
//                   Attach APK File
//                 </label>
//                 <label
//                   className="flex  cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
//                   tabIndex="0"
//                 >
//                   <span htmlFor="photo-dropbox" className="flex items-center space-x-2">
//                         <svg className="h-6 w-6 stroke-gray-400" viewBox="0 0 256 256">
//                           <path
//                             d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
//                             fill="none"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={24}
//                           />
//                           <path
//                             d="M80,128a80,80,0,1,1,144,48"
//                             fill="none"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={24}
//                           />
//                           <polyline
//                             points="118.1 161.9 152 128 185.9 161.9"
//                             fill="none"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={24}
//                           />
//                           <line
//                             x1={152}
//                             y1={208}
//                             x2={152}
//                             y2={128}
//                             fill="none"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={24}
//                           />
//                         </svg>
//                         <span className="text-xs font-medium text-gray-600">
//                           Drop files to Attach, or
//                           <span className="text-blue-600 underline">browse</span>
//                         </span>
//                       </span>
//                   <input
//                     id="upload"
//                     type="file"
//                     className="hidden"
//                     onChange={handleFileChange}
//                     accept=".apk"
//                   />
//                 </label>
//               </div>
//               {errors.selectedFile && (
//                 <p className="text-red-500 text-sm">{errors.selectedFile}</p>
//               )}
//               {selectedFilePath && (
//                 <p className="text-gray-500 text-sm">{selectedFilePath}</p>
//               )}

//               <div
//                 className="grid grid-cols-1 space-y-2"
//                 onDragOver={handleDragOverThumbnail}
//                 onDrop={handleDropThumbnail}
//               >
//                 <label className="text-sm font-bold text-gray-500 tracking-wide mt-4">
//                   Attach Thumbnail File
//                 </label>
//                 <label
//                   className="flex cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
//                   tabIndex="0"
//                 >
//                   <span className="flex items-center space-x-2">
//                       <svg className="h-6 w-6 stroke-gray-400" viewBox="0 0 256 256">
//                         <path
//                           d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                         <path
//                           d="M80,128a80,80,0,1,1,144,48"
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                         <polyline
//                           points="118.1 161.9 152 128 185.9 161.9"
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                         <line
//                           x1={152}
//                           y1={208}
//                           x2={152}
//                           y2={128}
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                       </svg>
//                       <span className="text-xs font-medium text-gray-600">
//                         Drop files to Attach, or
//                         <span className="text-blue-600 underline">browse</span>
//                       </span>
//                     </span>
//                   <input
//                     id="uploadThumbnail"
//                     type="file"
//                     className="hidden"
//                     onChange={handleThumbnailChange}
//                     accept=".jpg, .jpeg, .png" // Add appropriate file types
//                   />
//                 </label>
//               </div>
//               {thumbnailFilePath && (
//                 <p className="text-gray-500 text-sm">{thumbnailFilePath}</p>
//               )}
//                {errors.thumbnailFile && (
//                 <p className="text-red-500 text-sm">{errors.thumbnailFile}</p>
//               )}
//               <div className="grid grid-cols-1 space-y-2">
//                 <label className="text-sm font-bold text-gray-500 tracking-wide">
//                   Status
//                 </label>
//                 <div className="flex items-center space-x-4">
//                   <div className="flex items-center">
//                     <input
//                       type="radio"
//                       id="active"
//                       name="status"
//                       value="active"
//                       checked={status === "active"}
//                       onChange={() => setStatus("active")}
//                     />
//                     <label htmlFor="active" className="ml-2">
//                       Active
//                     </label>
//                   </div>
//                   <div className="flex items-center">
//                     <input
//                       type="radio"
//                       id="inactive"
//                       name="status"
//                       value="inactive"
//                       checked={status === "inactive"}
//                       onChange={() => setStatus("inactive")}
//                     />
//                     <label htmlFor="inactive" className="ml-2">
//                       Inactive
//                     </label>
//                   </div>
//                 </div>
//               </div>
//               {errors.status && (
//                 <p className="text-red-500 text-sm">{errors.status}</p>
//               )}
              
//               <div>
//               {apkTenantstatus && (
//                 <p
//                   className={`text-center ${
//                     status.includes("Please")
//                       ? "text-green-500"
//                       : "text-red-500"
//                   }`}
//                 >
//                   {apkTenantstatus}
//                 </p>
//               )}
//               <div className="flex justify-end">
//               <button
//       type="submit"
//       disabled={loading} // Disable the button when loading is true
//       style={{ backgroundColor: currentColor, color: "white" }}
//       className="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
//     >
//       {loading ? "Submitting..." : "Submit"}
//     </button>
//                 </div>
//               </div>
//             </form>
            
//           </div>
//         </div>
//       </div>
//       {/* <ToastContainer /> */}
//     </div>
    
//   );
// };
// export default APKForm;


import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import { useStateContext } from "../contexts/ContextProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const API_URL = process.env.REACT_APP_API_URL_V;
const APKForm = ({ onCloseForm, fetchDataFromApkMaster }) => {
  const { currentColor } = useStateContext();
  const [appName, setAppName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFilePath, setSelectedFilePath] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailFilePath, setThumbnailFilePath] = useState(null);
  const [status, setStatus] = useState("active");
  const [loading, setLoading] = useState(false);
  const [apkTenantstatus, setApkTenantStatus] = useState("");
  const [id, setId] = useState("");
  const [packageName, setPackageName] = useState("");
  const [version, setVersion] = useState("");
  // useEffect(() => {
  //   // Fetch data from the backend when the component mounts
  //   fetchDataFromApkMaster();
  // }, []);
  const [errors, setErrors] = useState({
    appName: "",
    id: "",
    selectedFile: "",
    thumbnailFile: "",
    status: "",
    packageName: "",
    version: "",
  });
  // Validation function
  const validateForm = () => {
    let valid = true;
    const newErrors = {
      appName: "",
      id: "",
      selectedFile: "",
      thumbnailFile: "",
      status: "",
      packageName: "",
      version: "",
    };
 
    if (!appName || !appName.trim()) {
      newErrors.appName = "App Name is required";
      valid = false;
    }
 
    if (!id || !id.trim()) {
      newErrors.id = "ID is required";
      valid = false;
    }
 
    if (!selectedFile) {
      newErrors.selectedFile = "APK File is required";
      valid = false;
    }
 
    if (!thumbnailFile) {
      newErrors.thumbnailFile = "Thumbnail File is required";
      valid = false;
    }
 
    if (!status) {
      newErrors.status = "Status is required";
      valid = false;
    }
    if (!packageName || !packageName.trim()) {
      newErrors.packageName = "Package Name is required";
      valid = false;
    }
 
    if (!version || !version.trim()) {
      newErrors.version = "Version is required";
      valid = false;
    }
 
    setErrors(newErrors);
    return valid;
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Add your form submission logic here
    const isValid = validateForm();
    if (isValid) {
      // Simulate form submission for demo purposes
 
      try {
        const formData = new FormData();
        formData.append("name", appName);
        formData.append("id", id);
        formData.append("status", status);
        formData.append("apk", selectedFile);
        formData.append("thumbnail", thumbnailFile);
        formData.append("packageName", packageName);
        formData.append("version", version);
 
        const accessToken = localStorage.getItem("accesstoken");
        const response = await fetch(`${API_URL}/apkmaster`, {
          method: "POST",
          headers: {
            // No need to set Content-Type for FormData
            "x-auth-token": accessToken,
          },
          body: formData,
        });
        if (response.ok) {
          const responseData = await response.json();
          fetchDataFromApkMaster();
          toast.success("Data created successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
 
          // Reset the form fields and selected file state after submission
          setAppName("");
          setSelectedFile(null);
          setSelectedFilePath(null);
          setThumbnailFile(null);
          setThumbnailFilePath(null);
          setStatus("");
          setApkTenantStatus("");
          setId("");
          setPackageName("");
          setVersion("");
          onCloseForm();
        } else {
          const responseData = await response.json();
          setApkTenantStatus(responseData.message);
          console.error("Form submission failed");
        }
      } catch (error) {
        console.error("Error during form submission", error);
 
        toast.error("Error updating data", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };
  const handleFileChange = (e) => {
    const file =
      e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
    setSelectedFile(file);
    // Display the selected file path
    if (file) {
      setSelectedFilePath(`Selected File: ${file.name}`);
    } else {
      setSelectedFilePath(null);
    }
  };
  const handleDragOverFile = (e) => {
    e.preventDefault();
  };
  const handleDropFile = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setSelectedFile(file);
    if (file) {
      setSelectedFilePath(`Selected File: ${file.name}`);
    } else {
      setSelectedFilePath(null);
    }
  };
  const handleThumbnailChange = (e) => {
    const file =
      e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
    setThumbnailFile(file);
 
    // Display the selected thumbnail file path
    if (file) {
      setThumbnailFilePath(`Selected Thumbnail: ${file.name}`);
    } else {
      setThumbnailFilePath(null);
    }
  };
 
  const handleDragOverThumbnail = (e) => {
    e.preventDefault();
  };
 
  const handleDropThumbnail = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setThumbnailFile(file);
 
    if (file) {
      setThumbnailFilePath(`Selected Thumbnail: ${file.name}`);
    } else {
      setThumbnailFilePath(null);
    }
  };
 
  return (
    <div className="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center overflow-y">
      <div className="modal bg-white w-full max-w-md p-6 rounded-lg overflow-y">
        <div className="relative bg-white rounded-lg shadow">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
            <h3 className="text-lg font-semibold text-gray-900">APK Details</h3>
            <button
              type="button"
              onClick={onCloseForm}
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 cursor-pointer absolute top-4 right-4"
            >
              <FaTimes />
            </button>
          </div>
          <div className="max-h-80 overflow-y-auto relative p-5">
            <form
              className="mt-2 space-y-2 "
              onSubmit={handleSubmit}
              encType="multipart/form-data"
            >
              <div className="grid grid-cols-1 space-y-2">
                <label className="text-sm font-bold text-gray-500 tracking-wide">
                  Apk Name
                </label>
                <input
                  value={appName}
                  onChange={(e) => setAppName(e.target.value)}
                  className="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
                  type="text"
                  placeholder="Your App Name"
                />
              </div>
              {errors.appName && (
                <p className="text-red-500 text-sm">{errors.appName}</p>
              )}
              <div className="grid grid-cols-1 space-y-2">
                <label className="text-sm font-bold text-gray-500 tracking-wide">
                  ID
                </label>
                <input
                  value={id}
                  onChange={(e) => setId(e.target.value)}
                  className="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
                  type="text"
                  placeholder="Your App ID"
                />
              </div>
              {errors.id && <p className="text-red-500 text-sm">{errors.id}</p>}
              <div className="grid grid-cols-1 space-y-2">
                <label className="text-sm font-bold text-gray-500 tracking-wide">
                  Package Name
                </label>
                <input
                  value={packageName}
                  onChange={(e) => setPackageName(e.target.value)}
                  className="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
                  type="text"
                  placeholder="Enter Package Name"
                />
              </div>
              {errors.packageName && (
                <p className="text-red-500 text-sm">{errors.packageName}</p>
              )}
              <div
                className="grid grid-cols-1 space-y-2"
                onDragOver={handleDragOverFile}
                onDrop={handleDropFile}
              >
                <label className="text-sm font-bold text-gray-500 tracking-wide mt-4">
                  Attach APK File
                </label>
                <label
                  className="flex  cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
                  tabIndex="0"
                >
                  <span
                    htmlFor="photo-dropbox"
                    className="flex items-center space-x-2"
                  >
                    <svg
                      className="h-6 w-6 stroke-gray-400"
                      viewBox="0 0 256 256"
                    >
                      <path
                        d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                      <path
                        d="M80,128a80,80,0,1,1,144,48"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                      <polyline
                        points="118.1 161.9 152 128 185.9 161.9"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                      <line
                        x1={152}
                        y1={208}
                        x2={152}
                        y2={128}
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                    </svg>
                    <span className="text-xs font-medium text-gray-600">
                      Drop files to Attach, or
                      <span className="text-blue-600 underline">browse</span>
                    </span>
                  </span>
                  <input
                    id="upload"
                    type="file"
                    className="hidden"
                    onChange={handleFileChange}
                    accept=".apk"
                  />
                </label>
              </div>
              {errors.selectedFile && (
                <p className="text-red-500 text-sm">{errors.selectedFile}</p>
              )}
              {selectedFilePath && (
                <p className="text-gray-500 text-sm">{selectedFilePath}</p>
              )}
 <div className="grid grid-cols-1 space-y-2">
                <label className="text-sm font-bold text-gray-500 tracking-wide">
                  version
                </label>
                <input
                  value={version}
                  onChange={(e) => setVersion(e.target.value)}
                  className="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
                  type="text"
                  placeholder="1.0.0"
                />
              </div>
              {errors.version && (
                <p className="text-red-500 text-sm">{errors.version}</p>
              )}
              <div
                className="grid grid-cols-1 space-y-2"
                onDragOver={handleDragOverThumbnail}
                onDrop={handleDropThumbnail}
              >
                <label className="text-sm font-bold text-gray-500 tracking-wide mt-4">
                  Attach Thumbnail File
                </label>
                <label
                  className="flex cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
                  tabIndex="0"
                >
                  <span className="flex items-center space-x-2">
                    <svg
                      className="h-6 w-6 stroke-gray-400"
                      viewBox="0 0 256 256"
                    >
                      <path
                        d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                      <path
                        d="M80,128a80,80,0,1,1,144,48"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                      <polyline
                        points="118.1 161.9 152 128 185.9 161.9"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                      <line
                        x1={152}
                        y1={208}
                        x2={152}
                        y2={128}
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={24}
                      />
                    </svg>
                    <span className="text-xs font-medium text-gray-600">
                      Drop files to Attach, or
                      <span className="text-blue-600 underline">browse</span>
                    </span>
                  </span>
                  <input
                    id="uploadThumbnail"
                    type="file"
                    className="hidden"
                    onChange={handleThumbnailChange}
                    accept=".jpg, .jpeg, .png" // Add appropriate file types
                  />
                </label>
              </div>
              {thumbnailFilePath && (
                <p className="text-gray-500 text-sm">{thumbnailFilePath}</p>
              )}
              {errors.thumbnailFile && (
                <p className="text-red-500 text-sm">{errors.thumbnailFile}</p>
              )}
              <div className="grid grid-cols-1 space-y-2">
                <label className="text-sm font-bold text-gray-500 tracking-wide">
                  Status
                </label>
                <div className="flex items-center space-x-4">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="active"
                      name="status"
                      value="active"
                      checked={status === "active"}
                      onChange={() => setStatus("active")}
                    />
                    <label htmlFor="active" className="ml-2">
                      Active
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="inactive"
                      name="status"
                      value="inactive"
                      checked={status === "inactive"}
                      onChange={() => setStatus("inactive")}
                    />
                    <label htmlFor="inactive" className="ml-2">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
              {errors.status && (
                <p className="text-red-500 text-sm">{errors.status}</p>
              )}
 
             
              <div>
                {apkTenantstatus && (
                  <p
                    className={`text-center ${
                      status.includes("Please")
                        ? "text-green-500"
                        : "text-red-500"
                    }`}
                  >
                    {apkTenantstatus}
                  </p>
                )}
               
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={loading} // Disable the button when loading is true
                    style={{ backgroundColor: currentColor, color: "white" }}
                    className="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
 
           
            </form>
          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
};
export default APKForm;